import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUpload,
  faTimes,
  faCheckCircle,
  faEye,
  faTrashAlt,
  faEyeSlash,
} from "@fortawesome/pro-light-svg-icons";
import { useDeepEffect } from "../../abstracts";
import { get, isEmpty, isNull } from "lodash";
import { isEmptyArray } from "formik";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const UploadComponentWithDrawalSpousal = (props) => {
  const {
    setFieldValue,
    label,
    name,
    values,
    clearUploadFile,
    setFileUploadRequired,
    setNewFile,
    clearField,
    setClearField,
    setShowFileName,
    fileExtensions,
    fieldName = "uploadSourceFile",
    setDocumentHidden,
    documentHidden,
    responseModel,
    isUploadSuccess = true,
  } = props;

  const [myFiles, setMyFiles] = useState(get(values, fieldName, []));
  // const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [responceFileData, getResponceFileData] = useState([]);
  const [edit, setEdit] = useState(false);
  const file = !isEmptyArray(responceFileData)
    ? responceFileData[0]
    : get(values, `${name}.0`);
  let size =
    (file?.size / 1024).toFixed(2) > 1000
      ? `${(file?.size / 1024 / 1024).toFixed(2)} MB`
      : `${(file?.size / 1024).toFixed(2)} KB`;

  function getBlobURL() {
    return URL.createObjectURL(myFiles[0]);
  }
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (myFiles?.length === 0) {
        setMyFiles([...myFiles, ...acceptedFiles]);
        setFieldValue(name, acceptedFiles);
        if (setNewFile) {
          setNewFile(name, acceptedFiles);
        }
      }
      // if (acceptedFiles.length === 0) {
      //   setIsUploadSuccess(false);
      // } else {
      //   setIsUploadSuccess(true);
      // }
    },
    [myFiles]
  );
  useDeepEffect(() => {
    if (clearField) {
      setMyFiles([]);
      setClearField(false);
      setShowFileName(true);
    }
  }, [clearField]);

  useEffect(() => {
    if (get(responseModel, name) != null) {
      // const reader = new FileReader();
      // const blob = dataURItoBlob(responseModel.promissoryNoteFileUpload);
      // reader.readAsDataURL(blob);
      let url = get(responseModel, name);
      if (!isEmptyArray(url)) {
        const toDataURL = (url) =>
          fetch(url)
            .then((response) => response.blob())
            .then(
              (blob) =>
                new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                })
            )
            .catch((error) => {});

        function getBase64Image(url) {
          var canvas = document.createElement("canvas");
          var dataURL = canvas.toDataURL("image/png");
          return dataURL;
        }

        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, { type: mime });
        }

        toDataURL(url).then((dataUrl) => {
          var fileData = !isEmpty(dataUrl)
            ? dataURLtoFile(
                dataUrl,
                getFileNameFromBlobPath(get(responseModel, name)) +
                  "." +
                  getFileExtensionFromBlobPath(get(responseModel, name))
              )
            : dataURLtoFile(
                getBase64Image(url),
                getFileNameFromBlobPath(get(responseModel, name)) +
                  "." +
                  getFileExtensionFromBlobPath(get(responseModel, name))
              );
          getResponceFileData([fileData]);
          setMyFiles([...myFiles, fileData]);
        });
      }
    }
  }, [responseModel]);
  // useDeepEffect(() => {
  //   setEdit(true);
  //   setMyFiles([get(values, fieldName, [])]);
  // }, [values]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: fileExtensions,
  });

  const removeFile = (file) => () => {
    const newFiles = [...myFiles];
    getResponceFileData([]);
    if (setFileUploadRequired) {
      setFileUploadRequired("");
    }
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
    if (clearUploadFile) {
      clearUploadFile();
    }
    if (setNewFile) {
      setNewFile([]);
      setFieldValue(name, []);
      setShowFileName(true);
    }
  };
  const newFileData = !isEmptyArray(responceFileData)
    ? responceFileData
    : myFiles;
  const files = newFileData.map((file) => (
    <div
      className="d-flex"
      style={{
        justifyContent: "flex-start",
        fontSize: "16px",
        fontWeight: "500",
      }}
    >
      <span
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: "80%",
          whiteSpace: "nowrap",
        }}
      >
        {!isEmpty(get(responseModel, name)) ? file.name : file.path}
      </span>
      <span
        className="ml-4"
        style={{ cursor: "pointer" }}
        onClick={removeFile(file)}
      >
        <FontAwesomeIcon
          icon={faTrashAlt}
          color={"#ff0000"}
          onClick={() => setFieldValue(name, [])}
        />
      </span>
    </div>
  ));
  const getClassName = isUploadSuccess
    ? "upload-docs border-color-normal"
    : "upload-docs border-color-red";
  function getFileNameFromBlobPath(url) {
    return url?.split("/")?.pop()?.split("_")[0];
  }
  function getFileExtensionFromBlobPath(url) {
    return url
      ?.split("/")
      ?.pop()
      ?.split("_")[1]
      ?.slice(
        ((url?.split("/")?.pop()?.split("_")[1].lastIndexOf(".") - 1) >>> 0) + 2
      );
  }
  return (
    <div>
      <label className="label-text">{label}</label>
      <div {...getRootProps({ className: "dropzone" })}>
        <input
          id={name}
          name={name}
          {...getInputProps()}
          disabled={myFiles?.length}
        />
        <div
          className={getClassName + " p-3"}
          style={{ borderRadius: "0px 10px 10px 0px" }}
        >
          {isEmptyArray(
            get(values, name, []) || get(responseModel, name, [])
          ) ? (
            <>
              <FontAwesomeIcon icon={faUpload} />
              <p> Drag & Drop Here</p>
              <p> or</p>
              <p className="link-text"> Browse file</p>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              {files}
              <div className="d-flex">
                <div style={{ color: "#777777", marginRight: "15px" }}>
                  {size}
                </div>{" "}
                |{" "}
                <div
                  style={{
                    cursor: "pointer",
                    color: "#2F80ED",
                    marginLeft: "15px",
                  }}
                  onClick={async () => {
                    setMyFiles([]);
                    setFieldValue(name, undefined);
                    await setTimeout(() => {
                      document.getElementById(name)?.click();
                    }, 500);
                  }}
                >
                  Reupload
                </div>
              </div>
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: "12px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      color={"#1C7E18"}
                      className="mr-2"
                    />
                    <div style={{ color: "#1C7E18" }}>
                      Uploaded Successfully{" "}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => setDocumentHidden(!documentHidden)}
                  >
                    <FontAwesomeIcon
                      icon={documentHidden ? faEye : faEyeSlash}
                      color={"#2F80ED"}
                      className="mr-3"
                    />
                    <div style={{ color: "#2F80ED" }}>
                      {" "}
                      {documentHidden ? "Preview" : "Hide"}{" "}
                    </div>
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
      </div>
      {/* <span className="file-type">Accepted File Type : {fileExtensions}</span> */}
      <p className="file-type-red">
        {!isUploadSuccess ? "WL013 : Required" : <></>}
      </p>
    </div>
  );
};

export default UploadComponentWithDrawalSpousal;
